import "../../App.css";
import "./css/profile.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ProSidebar } from "../../components/general/ProSidebar";
import { API_ENDPOINTS } from '../../config/apiConfig';
import { useAuth } from '../../components/router/authContext';

function Profile() {
  const [authenticated, setAuthenticated] = useState(false);
  const [userData, setUserData] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [activeSection, setActiveSection] = useState('personal');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { logout } = useAuth();
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");

  // Toggle main sidebar collapse
  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  // Fetch user data
  useEffect(() => {
    setLoading(true);
    axios
      .get(API_ENDPOINTS.user, {
        headers: {
          Authorization: `Token ${authToken}`,
        },
      })
      .then((response) => {
        setAuthenticated(true);
        setUserData(response.data);
        setFormData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setAuthenticated(false);
        navigate('/login');
      });

    setLoading(false);

  }, [navigate, authToken]);

  if (!formData || !userData) {
    return (
      <div className="container-flex-row">
        <ProSidebar collapsed={collapsed} toggleCollapse={toggleCollapse} />
      </div>
    );
  }

  console.log("FORM DATA", formData);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      setFormData(prev => ({
        ...prev,
        notification_preferences: {
          ...prev.notification_preferences,
          [name]: checked
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMessage('Changes saved successfully!');
    setErrorMessage('Error saving changes. Please try again.');
    
    axios.post(API_ENDPOINTS.updateProfile, formData, {
      headers: {
        Authorization: `Token ${authToken}`,
      },
    })
    .then(response => {
      setUserData(response.data);
      setSuccessMessage('Profile updated successfully!');
      setIsEditing(false);
      setLoading(false);
    })
    .catch(error => {
      setErrorMessage('Failed to update profile. Please try again.');
      setLoading(false);
    });

    // In a real app, you would send this to your API
    // axios.put(`${API_ENDPOINTS.user}/${userData.id}/`, formData, {
    //   headers: {
    //     Authorization: `Token ${authToken}`,
    //   },
    // })
    // .then(response => {
    //   setUserData(formData);
    //   setSuccessMessage('Profile updated successfully!');
    //   setIsEditing(false);
    //   setLoading(false);
      
    //   // Clear success message after 3 seconds
    //   setTimeout(() => {
    //     setSuccessMessage('');
    //   }, 3000);
    // })
    // .catch(error => {
    //   setErrorMessage('Failed to update profile. Please try again.');
    //   setLoading(false);
      
    //   // Clear error message after 3 seconds
    //   setTimeout(() => {
    //     setErrorMessage('');
    //   }, 3000);
    // });
  };

  // Cancel editing
  const handleCancel = () => {
    setFormData(userData);
    setIsEditing(false);
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  if (loading && !userData) {
    return (
      <div className="container-flex-row">
        <ProSidebar collapsed={collapsed} toggleCollapse={toggleCollapse} />
        <div className="pro-calculator-content sidebar-adjustment">
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading your profile...</p>
          </div>
        </div>
      </div>
    );
  }

  // Render personal information form
  const renderPersonalInfo = () => {
    return (
      <div className="profile-section-content">
        <h2>Personal Information</h2>
        <p className="section-description">Manage your personal details and contact information.</p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="first_name">First Name</label>
              <input
                type="text"
                id="first_name"
                name="first_name"
                value={formData.first_name || ''}
                onChange={handleInputChange}
                disabled={!isEditing}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="last_name">Last Name</label>
              <input
                type="text"
                id="last_name"
                name="last_name"
                value={formData.last_name || ''}
                onChange={handleInputChange}
                disabled={!isEditing}
                required
              />
            </div>
          </div>
          
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email || ''}
              onChange={handleInputChange}
              disabled={!isEditing}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="phone_number">Phone Number</label>
            <input
              type="tel"
              id="phone_number"
              name="phone_number"
              value={formData.phone_number || ''}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="address">Address</label>
            <textarea
              id="address"
              name="address"
              value={formData.address || ''}
              onChange={handleInputChange}
              disabled={!isEditing}
              rows="3"
            ></textarea>
          </div>
          <div className="form-group">
            <label htmlFor="company_name">Company Name</label>
            <input
              type="text"
              id="company_name"
              name="company_name"
              value={formData.company_name || ''}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
          </div>
          
          {isEditing ? (
            <div className="form-actions">
              <button type="submit" className="btn-save btn-custom" disabled={loading} onClick={handleSubmit}>
                {loading ? 'Saving...' : 'Save Changes'}
              </button>
              <button type="button" className="btn-cancel btn-custom" onClick={handleCancel}>
                Cancel
              </button>
            </div>
          ) : (
            <button type="button" className="btn-edit btn-custom" onClick={() => setIsEditing(true)}>
              Edit Information
            </button>
          )}
          <button className="btn-logout btn-custom" onClick={handleLogout}> Logout </button>
        </form>
      </div>
    );
  };

  // Render company information form
  const renderCompanyInfo = () => {
    return (
      <div className="profile-section-content">
        <h2>Company Information</h2>
        <p className="section-description">Manage your company details.</p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="company_name">Company Name</label>
            <input
              type="text"
              id="company_name"
              name="company_name"
              value={formData.company_name || ''}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="industry">Industry</label>
            <select
              id="industry"
              name="industry"
              value={formData.industry || ''}
              onChange={handleInputChange}
              disabled={!isEditing}
            >
              <option value="">Select Industry</option>
              <option value="logistics">Logistics</option>
              <option value="transportation">Transportation</option>
              <option value="manufacturing">Manufacturing</option>
              <option value="retail">Retail</option>
              <option value="other">Other</option>
            </select>
          </div>
          
          {/* <div className="form-group">
            <label htmlFor="company_size">Company Size</label>
            <select
              id="company_size"
              name="company_size"
              value={formData.company_size || ''}
              onChange={handleInputChange}
              disabled={!isEditing}
            >
              <option value="">Select Company Size</option>
              <option value="1-10">1-10 employees</option>
              <option value="11-50">11-50 employees</option>
              <option value="51-200">51-200 employees</option>
              <option value="201-500">201-500 employees</option>
              <option value="501+">501+ employees</option>
            </select>
          </div> */}
          
          {isEditing ? (
            <div className="form-actions">
              <button type="submit" className="btn-save btn-custom" disabled={loading}>
                {loading ? 'Saving...' : 'Save Changes'}
              </button>
              <button type="button" className="btn-cancel btn-custom" onClick={handleCancel}>
                Cancel
              </button>
            </div>
          ) : (
            <button type="button" className="btn-edit btn-custom" onClick={() => setIsEditing(true)}>
              Edit Information
            </button>
          )}
        </form>
      </div>
    );
  };

  // Render notification preferences
  const renderNotifications = () => {
    return (
      <div className="profile-section-content">
        <h2>Notification Preferences</h2>
        <p className="section-description">Manage how and when you receive notifications.</p>
        
        <form onSubmit={handleSubmit}>
          <div className="notification-options">
            <div className="notification-option">
              <div className="notification-info">
                <h3>Email Notifications</h3>
                <p>Receive important updates via email</p>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  name="email_notifications"
                  checked={formData.notification_preferences?.email_notifications || false}
                  onChange={handleInputChange}
                  disabled={!isEditing}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
            
            <div className="notification-option">
              <div className="notification-info">
                <h3>SMS Notifications</h3>
                <p>Receive important updates via text message</p>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  name="sms_notifications"
                  checked={formData.notification_preferences?.sms_notifications || false}
                  onChange={handleInputChange}
                  disabled={!isEditing}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
            
            <div className="notification-option">
              <div className="notification-info">
                <h3>Weekly Reports</h3>
                <p>Receive weekly summary reports of your fleet performance</p>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  name="weekly_reports"
                  checked={formData.notification_preferences?.weekly_reports || false}
                  onChange={handleInputChange}
                  disabled={!isEditing}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
            
            <div className="notification-option">
              <div className="notification-info">
                <h3>Marketing Emails</h3>
                <p>Receive updates about new features and promotions</p>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  name="marketing_emails"
                  checked={formData.notification_preferences?.marketing_emails || false}
                  onChange={handleInputChange}
                  disabled={!isEditing}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>
          
          {isEditing ? (
            <div className="form-actions">
              <button type="submit" className="btn-save btn-custom" disabled={loading}>
                {loading ? 'Saving...' : 'Save Changes'}
              </button>
              <button type="button" className="btn-cancel btn-custom" onClick={handleCancel}>
                Cancel
              </button>
            </div>
          ) : (
            <button type="button" className="btn-edit btn-custom" onClick={() => setIsEditing(true)}>
              Edit Preferences
            </button>
          )}
        </form>
      </div>
    );
  };

  // Render account settings
  const renderAccountSettings = () => {
    return (
      <div className="profile-section-content">
        <h2>Account Settings</h2>
        <p className="section-description">Manage your account settings and subscription.</p>
        
        <div className="account-info-card">
          <div className="account-info-header">
            <h3>Account Information</h3>
          </div>
          <div className="account-info-body">
            <div className="account-info-row">
              <span className="account-info-label">Username:</span>
              <span className="account-info-value">{userData.username}</span>
            </div>
            <div className="account-info-row">
              <span className="account-info-label">Subscription Type:</span>
              <span className="account-info-value account-type-badge">{userData.subscription_type}</span>
            </div>
            <div className="account-info-row">
              <span className="account-info-label">Subscription Status:</span>
              <span className={`account-info-value status-badge ${userData.subscription_status.toLowerCase()}`}>
                {userData.subscription_status}
              </span>
            </div>
            <div className="account-info-row">
              <span className="account-info-label">Subscription Expiration Date:</span>
              <span className="account-info-value">{userData.subscription_end_date}</span>
            </div>
          </div>
          {/* <div className="account-info-footer">
            <button className="btn-upgrade ">Upgrade Plan</button>
            <button className="btn-manage-subscription">Manage Subscription</button>
          </div> */}
        </div>
        
        {/* <div className="account-actions">
          <div className="account-action-card">
            <h3>Change Password</h3>
            <p>Update your password to keep your account secure.</p>
            <button className="btn-account-action">Change Password</button>
          </div>
          
          <div className="account-action-card">
            <h3>Two-Factor Authentication</h3>
            <p>Add an extra layer of security to your account.</p>
            <button className="btn-account-action">Enable 2FA</button>
          </div>
          
          <div className="account-action-card danger-zone">
            <h3>Delete Account</h3>
            <p>Permanently delete your account and all associated data.</p>
            <button className="btn-danger">Delete Account</button>
          </div>
        </div> */}
      </div>
    );
  };

  // Render billing information
  const renderBilling = () => {
    return (
      <div className="profile-section-content">
        <h2>Billing Information</h2>
        <p className="section-description">Manage your payment methods and billing history.</p>
        
        <div className="payment-methods">
          <h3>Payment Methods</h3>
          
          <div className="payment-method-card">
            <div className="payment-method-icon">
              <i className="fa fa-credit-card"></i>
            </div>
            <div className="payment-method-details">
              <h4>Visa ending in 4242</h4>
              <p>Expires 12/2024</p>
              <p className="payment-method-default">Default</p>
            </div>
            <div className="payment-method-actions">
              <button className="btn-edit-small">Edit</button>
              <button className="btn-remove">Remove</button>
            </div>
          </div>
          
          <button className="btn-add-payment">Add Payment Method</button>
        </div>
        
        <div className="billing-history">
          <h3>Billing History</h3>
          
          <div className="billing-table">
            <div className="billing-table-header">
              <div className="billing-date">Date</div>
              <div className="billing-description">Description</div>
              <div className="billing-amount">Amount</div>
              <div className="billing-status">Status</div>
              <div className="billing-actions">Actions</div>
            </div>
            
            <div className="billing-table-row">
              <div className="billing-date">Nov 1, 2023</div>
              <div className="billing-description">Pro Plan - Monthly</div>
              <div className="billing-amount">$49.99</div>
              <div className="billing-status">
                <span className="status-badge paid">Paid</span>
              </div>
              <div className="billing-actions">
                <button className="btn-invoice">Invoice</button>
              </div>
            </div>
            
            <div className="billing-table-row">
              <div className="billing-date">Oct 1, 2023</div>
              <div className="billing-description">Pro Plan - Monthly</div>
              <div className="billing-amount">$49.99</div>
              <div className="billing-status">
                <span className="status-badge paid">Paid</span>
              </div>
              <div className="billing-actions">
                <button className="btn-invoice">Invoice</button>
              </div>
            </div>
            
            <div className="billing-table-row">
              <div className="billing-date">Sep 1, 2023</div>
              <div className="billing-description">Pro Plan - Monthly</div>
              <div className="billing-amount">$49.99</div>
              <div className="billing-status">
                <span className="status-badge paid">Paid</span>
              </div>
              <div className="billing-actions">
                <button className="btn-invoice">Invoice</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render the active section content
  const renderActiveSection = () => {
    switch (activeSection) {
      case 'personal':
        return renderPersonalInfo();
      case 'company':
        return renderCompanyInfo();
      case 'notifications':
        return renderNotifications();
      case 'account':
        return renderAccountSettings();
      case 'billing':
        return renderBilling();
      default:
        return renderPersonalInfo();
    }
  };

  return (
    <div className="container-flex-row">
      <ProSidebar collapsed={collapsed} toggleCollapse={toggleCollapse} />
      <div className="pro-calculator-content sidebar-adjustment">
        <div className="profile-container">
          <div className="profile-header">
            <h1>My Profile</h1>
          </div>
          
          {successMessage && (
            <div className="alert alert-success">
              {/* <FontAwesomeIcon icon={faCheck} /> */} {successMessage}
            </div>
          )}
          
          {errorMessage && (
            <div className="alert alert-error">
              {/* <FontAwesomeIcon icon={faTimes} /> */} {errorMessage}
            </div>
          )}
          
          <div className="profile-content">
            <div className="profile-sidebar">
              {/* <div className="profile-user-info">
                <div className="profile-avatar">
                  {userData.first_name && userData.last_name ? 
                    `${userData.first_name.charAt(0)}${userData.last_name.charAt(0)}` : 
                    'U'}
                </div>
                <div className="profile-user-details">
                  <h3>{userData.first_name} {userData.last_name}</h3>
                  <p>{userData.email}</p>
                </div>
              </div> */}
              
              <nav className="profile-nav">
                <ul>
                  <li className={activeSection === 'personal' ? 'active' : ''}>
                    <button onClick={() => setActiveSection('personal')}>
                      {/* <FontAwesomeIcon icon={faUser} /> */}
                      <span>Personal Information</span>
                    </button>
                  </li>
                  {/* <li className={activeSection === 'company' ? 'active' : ''}>
                    <button onClick={() => setActiveSection('company')}>
                      /* <FontAwesomeIcon icon={faBuilding} /> *
                      <span>Company Information</span>
                    </button>
                  </li> */}
                  <li className={activeSection === 'notifications' ? 'active' : ''}>
                    <button onClick={() => setActiveSection('notifications')}>
                      {/* <FontAwesomeIcon icon={faBell} /> */}
                      <span>Notification Preferences</span>
                    </button>
                  </li>
                  <li className={activeSection === 'account' ? 'active' : ''}>
                    <button onClick={() => setActiveSection('account')}>
                      {/* <FontAwesomeIcon icon={faShield} /> */}
                      <span>Account Settings</span>
                    </button>
                  </li>
                  {/* <li className={activeSection === 'billing' ? 'active' : ''}>
                    <button onClick={() => setActiveSection('billing')}>
                      /* <FontAwesomeIcon icon={faCreditCard} /> 
                      <span>Billing Information</span>
                    </button>
                  </li> */}
                </ul>
              </nav>
            </div>
            
            <div className="profile-main">
              {renderActiveSection()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
